// Partner-owned domains that are locked to a single HMO tenant. Any path on one
// of these hosts outside that partner's HMO pages (or the shared payment flows
// below) redirects to the partner's HMO page.
export const customDomainHmoSubdomains: Record<string, string> = {
  "telemedicine.leadwayhealth.com": "leadway-health",
};

// Shared flows reachable from partner links, including payment provider
// callbacks built from window.location.origin.
const sharedPathPrefixes = ["/drug-payment", "/test-payment"];

const isUnderPath = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export function isAllowedOnCustomDomain(pathname: string, subdomain: string) {
  return [`/hmo/${subdomain}`, ...sharedPathPrefixes].some((prefix) =>
    isUnderPath(pathname, prefix),
  );
}
